import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Ripple} from '../Ripple/Ripple';

type RoundButtonColorType = 'secondary' | 'primary';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?:
    | keyof JSX.IntrinsicElements
    | React.ComponentType<React.PropsWithChildren>;
  disabledRipple?: boolean;
  backgroundColor?: RoundButtonColorType;
  className?: string;
  refObject?: React.RefObject<HTMLElement>;
}

export const CircleButton = React.forwardRef<HTMLElement, Props>(
  function CircleButton({disabledRipple, ...props}, refObject) {
    if (disabledRipple) {
      return <StyledButton {...props} ref={refObject} />;
    }
    return <Ripple as={StyledButton} {...props} ref={refObject} />;
  },
);

const StyledButton = styled.button<{
  backgroundColor?: RoundButtonColorType;
}>`
  width: 36px;
  height: 36px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 36px;
  padding: 5px;
  ${props => {
    switch (props.backgroundColor) {
      case 'primary':
        return css`
          color: ${COLORS.White};
          background-color: ${COLORS.Black};
        `;
      case 'secondary':
        return css`
          background-color: ${COLORS.White};
        `;
      default:
        return css`
          background-color: transparent;
        `;
    }
  }};

  overflow: visible;
  display: inline-block;
  border-radius: 50%;
`;
